import * as React from 'react'
import type { ENTITY_TYPES } from '@sales-center/common'
import { OwnerSelect } from '@user/components/Owner/OwnerSelect'
import type { OwnerOption } from './ActivityFormFields.types'

type Props = {
  salesTeamId: number
  ownerId?: string
  owners?: OwnerOption[]
  entityType?: ENTITY_TYPES
}

// Shared Owner field used by both the default and attach-mode activity layouts
// so the OwnerSelect wiring lives in one place. entityType scopes the owner list
// to the attached record's permissions (defaults to Lead inside OwnerSelect).
export function ActivityOwnerField({
  salesTeamId,
  ownerId,
  owners,
  entityType,
}: Props) {
  return (
    <OwnerSelect
      salesTeamId={`${salesTeamId}`}
      label="Owner"
      margin="normal"
      name="ownerId"
      size="small"
      defaultValue={ownerId}
      useAdditionalMargin
      unassignedOption
      owners={owners}
      entityType={entityType}
      required
      data-test-id={`activity-form-owner-select`}
    />
  )
}
